import { combineReducers } from 'redux';

import { filters } from '@zoopla/redux-reducer-filters';
import { listingsSortOrder } from '@zoopla/redux-reducer-sort-order';
import { searchResults } from '@zoopla/redux-reducer-search-results';
import { taxonomy } from '@zoopla/redux-reducer-taxonomy';
import { user } from '@zoopla/redux-reducer-user';

export const rootReducer = combineReducers({
    filters,
    listingsSortOrder,
    searchResults,
    taxonomy,
    user
});
